export const DEFAULT_TOAST_DURATION = 3000;
export const DEFAULT_SHORT_TOAST_DURATION = 1500;
